module.exports = __webpack_public_path__ + "img/hekmat-iranian.edcabff4.png";